import React, { FC } from 'react';
import { useParams } from 'react-router';
import Edit from 'components/fields/components/Edit';

const Screen: FC = () => {
  const { id } = useParams<{ id: string | undefined }>();

  return (
    <Edit
      fieldsEntityName="fields"
      fieldsEntityEndpoint={`fields?id=${id}`}
      fieldsDropdownsEntityName="field-dropdowns"
      fieldsDropdownsEntityEndpoint="fields/dropdown-options"
    />
  );
};

export default Screen;
